module.exports = __webpack_public_path__ + "static/img/moren.8df52e97.jpg";